import { a as languages } from "../../core-8vQkh0Rd.js";
import { n as clikeComment, t as boolean } from "../../patterns-C0vJBvXO.js";
//#region src/prism/languages/yang.js
languages.yang = {
	"comment": clikeComment,
	"string": /"(?:\\.|[^\\"])*"|'[^']*'/g,
	"keyword": {
		pattern: /(^|[{};\n][ 	]*)[a-z_][\w.-]*/i,
		lookbehind: true
	},
	"namespace": {
		pattern: /(\s)[a-z_][\w.-]*(?=:)/i,
		lookbehind: true
	},
	"boolean": boolean,
	"operator": /\+/,
	"punctuation": /[{}:;]/
};
//#endregion

//# sourceMappingURL=yang.js.map